<p-fluid>
    <div class="flex flex-col gap-6">
        <div class="flex items-center gap-3">
            <p-checkbox inputId="kyc-require-deposit" [binary]="true" [disabled]="disabled()" [ngModel]="value().RequireForDeposit" (ngModelChange)="setField('RequireForDeposit', $event)" />
            <label for="kyc-require-deposit">Require KYC for deposit</label>
        </div>
        <div class="flex items-center gap-3">
            <p-checkbox inputId="kyc-require-withdrawal" [binary]="true" [disabled]="disabled()" [ngModel]="value().RequireForWithdrawal" (ngModelChange)="setField('RequireForWithdrawal', $event)" />
            <label for="kyc-require-withdrawal">Require KYC for withdrawal</label>
        </div>
    </div>
</p-fluid>
